"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../../../utils");

var _getIsAdmin = require("ui-addon-upgrades/_core/common/eligibility/getIsAdmin");

var _AdminTypes = require("ui-addon-upgrades/_core/common/constants/AdminTypes");

var AdminModalTypes = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/constants/AdminModalTypes"));

var _AdminModal = _interopRequireDefault(require("./AdminModal"));

var AdminOnlyWrapper =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(AdminOnlyWrapper, _Component);

  function AdminOnlyWrapper(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AdminOnlyWrapper);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AdminOnlyWrapper).call(this, props));
    _this.state = {
      isAdmin: false,
      showAdminModal: false
    };
    return _this;
  }

  (0, _createClass2.default)(AdminOnlyWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var adminType = this.props.adminType;
      (0, _getIsAdmin.getIsAdmin)(adminType).then(function (isAdmin) {
        return _this2.setState({
          isAdmin: isAdmin
        });
      });
    }
  }, {
    key: "renderChild",
    value: function renderChild() {
      var _this3 = this;

      var isAdmin = this.state.isAdmin;
      var children = this.props.children;

      var child = _react.Children.only(children);

      if (!isAdmin) {
        var newProps = (0, _utils.omit)((0, _extends2.default)({}, child.props, {
          onClick: function onClick() {
            return _this3.setState({
              showAdminModal: true
            });
          }
        }), 'href');
        return _react.default.createElement(child.type, newProps);
      }

      return child;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var showAdminModal = this.state.showAdminModal;
      var _this$props = this.props,
          modalType = _this$props.modalType,
          merchandiseId = _this$props.merchandiseId;
      return _react.default.createElement(_react.default.Fragment, null, showAdminModal && _react.default.createElement(_AdminModal.default, {
        modalType: modalType,
        merchandiseId: merchandiseId,
        onClose: function onClose() {
          return _this4.setState({
            showAdminModal: false
          });
        }
      }), this.renderChild());
    }
  }]);
  return AdminOnlyWrapper;
}(_react.Component);

AdminOnlyWrapper.defaultProps = {
  adminType: _AdminTypes.TEAM,
  modalType: AdminModalTypes.DEFAULT
};
AdminOnlyWrapper.propTypes = {
  adminType: _propTypes.default.oneOf([_AdminTypes.BILLING, _AdminTypes.TEAM]).isRequired,
  children: _propTypes.default.node.isRequired,
  merchandiseId: _propTypes.default.number,
  modalType: _propTypes.default.oneOf(Object.values(AdminModalTypes || {}))
};
var _default = AdminOnlyWrapper;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/components/AdminOnlyWrapper.js
// module id = 332
// module chunks = 5 6